<script setup>
defineProps({
  modelli: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: '',
  },
})

const openModelloId = ref(null)

const toggleModello = (id) => {
  openModelloId.value = openModelloId.value === id ? null : id
}
</script>

<template>
  <div class="adda-accordion-section row-400-20 p-bot-1 max">
    <!-- eslint-disable vue/no-v-html -->
    <div class="blocks-container">
      <h2 class="heading-1 title" v-html="title" />
      <div class="modelli-container">
        <div
          v-for="modello in modelli"
          :key="modello.id"
          class="modello"
          :class="[{ open: openModelloId === modello.id }]"
          @click="toggleModello(modello.id)"
        >
          <div class="first-level">
            <div class="heading-2-b modello-title" v-html="modello.titolo" />
            <div class="modello-icon">
              <img src="@/assets/img/ico/arrows3.svg" alt="DigitXS Icon" />
            </div>
          </div>
          <div
            v-show="openModelloId === modello.id"
            class="modello-text"
            v-html="modello.testo"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddaAccordion',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
